module.exports = __webpack_public_path__ + "media/public/logoEscura-d82c67f4.svg";